import List from "@/components/visualizations/List/List";
import useTranslation from "@/hooks/useTranslation";
import Widget from "@/pages/dashboard/components/Widget/Widget";
import {
  ProductBy,
  useProductTransportImpactPerMode,
} from "@/pages/dashboard/hooks/useProductImpact";
import { transportIcon } from "@/pages/dashboard/TransportDashboard/widgets/TransportImpactTopContributors";
import { formatAmountWithUnit, formatTransportLabel } from "@/pages/dashboard/utils/formatters";
import { ImpactMetric } from "@/pages/dashboard/utils/types";

function ProductTransportImpactPerType({
  productId,
  metric,
  by,
}: {
  productId: number;
  metric: ImpactMetric;
  by: ProductBy;
}) {
  const { data, isLoading, isFetching } = useProductTransportImpactPerMode({
    productId,
    by,
    metric: metric.key,
  });

  const translation = useTranslation();

  const listData = data
    ? data
        .filter((row) => row.travel_mode) // TODO: hack! filter out the empty values
        .map((row) => {
          return {
            icon: transportIcon(row.travel_mode),
            label: formatTransportLabel(row.travel_mode),
            value: row.impact?.[metric.key] || 0,
            extraProp: {
              label: "Distance",
              value: formatAmountWithUnit(row.distance, "km", 0),
            },
          };
        })
    : [];

  const total = listData.reduce((acc, curr) => acc + curr.value, 0);

  return (
    <Widget
      title={translation["productDrawer"]["topContributorsTransport"]["title"]}
      tooltip={translation["productDrawer"]["topContributorsTransport"]["description"]}
    >
      <List
        loading={isLoading || isFetching}
        data={{
          list: listData,
          total: total,
        }}
        format={metric.formatter}
      />
    </Widget>
  );
}

export default ProductTransportImpactPerType;
